import { useTranslation } from "react-i18next";
import { ContentHeader, MainContentArea } from "melco-ui";
import { useBreadcrumb } from "../../hooks/navigation/useBreadcrumb";
import { AddGroupButton } from "../../components/reporting/machineStatus/AddGroupButton";
import { MachineGroupsList } from "../../components/reporting/machineGroups/MachineGroupsList";

export const MachineGroups: React.FC = () => {
  const { t } = useTranslation();

  const breadcrumb = useBreadcrumb("reporting");
  return (
    <MainContentArea
      header={
        <ContentHeader
          title={t("reporting.machinegroups.title")}
          breadcrumb={breadcrumb}
          extra={
            <>
              <AddGroupButton />
            </>
          }
        />
      }
    >
      <MachineGroupsList />
    </MainContentArea>
  );
};
